import React, { createContext, useContext, useState, useCallback } from 'react';
import { TELEGRAM_DARK, TELEGRAM_LIGHT, TelegramTheme } from './telegramColors';

type ThemeMode = 'dark' | 'light';

interface ChatThemeContextValue {
  mode: ThemeMode;
  colors: TelegramTheme;
  toggleMode: () => void;
}

const ChatThemeContext = createContext<ChatThemeContextValue>({
  mode: 'dark',
  colors: TELEGRAM_DARK,
  toggleMode: () => {},
});

export const useChatTheme = () => useContext(ChatThemeContext);

export const ChatThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [mode, setMode] = useState<ThemeMode>(() => {
    const saved = localStorage.getItem('chatPreviewTheme');
    return saved === 'light' ? 'light' : 'dark';
  });

  const toggleMode = useCallback(() => {
    setMode((prev) => {
      const next = prev === 'dark' ? 'light' : 'dark';
      localStorage.setItem('chatPreviewTheme', next);
      return next;
    });
  }, []);

  const colors = mode === 'dark' ? TELEGRAM_DARK : TELEGRAM_LIGHT;

  return (
    <ChatThemeContext.Provider value={{ mode, colors, toggleMode }}>
      {children}
    </ChatThemeContext.Provider>
  );
};
